import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryPromoCodeDiscount.js';
import { RichText } from '@synergycms_core/components/generic';
import connect from 'react-redux/es/connect/connect';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import Price from '@synergycms_core/components/generic/Price';

const AvailMainSideSummaryPromoCodeDiscount = class AvailMainSideSummaryPromoCodeDiscount extends React.Component {
  static displayName = 'AvailMainSideSummaryPromoCodeDiscount';

  render() {
    const { config, theme } = this.props,
      {
        promoCodeDiscount,
        promoCode,
        stepCode
      } = config;

    const { classes } = theme.styles;

    return (
      <div className={classes.contentModuleRow}>
        <RichText text={promoCode} innerStyle={['roboto15GreenBold', 'uppercase', classes.contentModuleCell, classes.large]} />
        <div className={[classes.contentModuleCell, classes.short].join(' ')}>
          <Price
            innerStyle={['roboto15GreenBold', classes.priceNumbers]}
            amount={promoCodeDiscount}
            forceHotelCurrency={stepCode === 'confirmation'}
          />
        </div>
      </div>
    );
  }
};

const mapStateToProps = (store, ownProps) => {
  return {
    stepCode: store.getIn(['customer', 'step', 'current_step', 'code']),
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, []),
  connect(
    mapStateToProps,
  ),
  PropertyManager([
    'promoCodeDiscount',
    'promoCode',
    'stepCode'
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryPromoCodeDiscount);
